module.exports = __webpack_public_path__ + "static/img/WisdomSiteThink.1597ad9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/WisdomSiteThink.jpg
// module id = b125
// module chunks = 12